import { Box, Flex, Text } from '@chakra-ui/react';

import {
  CustomDrawerFooter,
  PrimaryButton,
} from '../../../../components/custom';
import { formatDate } from '../../../../helpers/utilityFunctions';
import { IBetCreditsPurchaseSummary } from '../../../../types/billPayment';

interface BetCreditsPurchaseSummaryProps {
  summary: IBetCreditsPurchaseSummary;
  handleSubmit: () => void;
}

export default function BetCreditsPurchaseSummary({
  summary,
  handleSubmit,
}: BetCreditsPurchaseSummaryProps) {
  return (
    <>
      <Box
        borderRadius="24px"
        borderWidth="1px"
        borderColor="#EBEDEF"
        w="full"
        marginTop={6}
        background="#fafafa"
      >
        <Box
          borderRadius="24px"
          backgroundColor="#001419"
          padding={{ base: '30px', md: '24px' }}
          py={4}
          mb={2}
        >
          <Text fontSize="1rem" color="#FFFFFF" lineHeight="1.5rem" mb={2}>
            Purchase Summary
          </Text>
          <Text fontSize=".875rem" color="#7B828E" lineHeight="1.5rem">
            Please confirm that the details below are correct.
          </Text>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          p="28px 24px 34px 24px"
          gap={6}
        >
          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Provider
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              {summary.providerName}
            </Text>
          </Flex>

          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Account Name
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              {summary.accountName}
            </Text>
          </Flex>

          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              User ID
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              {summary.clientId}
            </Text>
          </Flex>

          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Amount
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              ₦{summary.amount}
            </Text>
          </Flex>

          <Flex justifyContent={'space-between'}>
            <Text fontSize=".875rem" lineHeight="1.5rem" color="#656B76" mr={2}>
              Date
            </Text>
            <Text
              fontSize=".875rem"
              lineHeight="1.5rem"
              color="#1A1C1F"
              fontWeight={500}
            >
              {formatDate(summary.date.toString())}
            </Text>
          </Flex>
        </Box>
      </Box>
      <Box mt="75%"></Box>

      <CustomDrawerFooter direction="column">
        <Flex justifyContent="space-between" ml={2} mr={4} mb={4} w={'98'}>
          <Text
            fontSize="1rem"
            lineHeight="1.5rem"
            fontWeight={500}
            color="#1A1C1F"
          >
            Total Amount
          </Text>
          <Text
            fontSize="1rem"
            lineHeight="1.5rem"
            fontWeight={500}
            color="#1A1C1F"
          >
            ₦{summary.amount}
          </Text>
        </Flex>
        <PrimaryButton onClick={handleSubmit} w="full" paddingY={4}>
          Continue
        </PrimaryButton>
      </CustomDrawerFooter>
    </>
  );
}
